import React from 'react';
import {connect} from 'react-redux';
import {Container, Grid, Card, Header, Dimmer, Form, Loader} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import TrackerDropDown from 'go/pages/tracker/trackerDropDown';
import {showDollarAmountWithDollar, getPercentage} from 'common/utils';
import {
  HOME,
  BUSINESS_OBJECTIVES_TRACKER,
} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import REST from 'go/requests/rest';
import {Alert} from 'componentLibrary';

export class BusinessObjectivesTracker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trackers: this.props.trackers,
      loading: true,
    };
  }

  componentDidMount() {
    document.title = BUSINESS_OBJECTIVES_TRACKER;

    this.getAllTrackers();
  }

  updatePageTitle = (selectedTrackerId) => {
    const {trackers} = this.state;
    const [currentTracker] = _.filter(
      trackers,
      (fo) => fo.trackerId == selectedTrackerId
    );
    document.title = `${HOME} - ${currentTracker.name}`;
  };

  getAllTrackers = () => {
    let storedTracker = _.get(
      JSON.parse(localStorage.getItem('lastTracker')),
      'selectedTrackerId'
    );
    REST.tracker
      .getTrackers(this.props.jwt)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          let selectedTrackerId;
          let sortedTrackers = _.orderBy(resJson, ['fundingOpportunityId'], ['desc']);
          if (storedTracker) {
            if (_.find(sortedTrackers, (tracker) => tracker.trackerId == storedTracker)) {
              selectedTrackerId = storedTracker;
            } else {
              selectedTrackerId = _.get(sortedTrackers, '0.trackerId');
            }
          } else {
            selectedTrackerId = _.get(sortedTrackers, '0.trackerId');
          }
          this.setState({
            trackers: sortedTrackers,
            selectedTrackerId,
            loading: false,
          });
          this.updatePageTitle(selectedTrackerId);
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  handleChange = (data) => {
    const selectedTrackerId = data;
    localStorage.setItem('lastTracker', JSON.stringify({selectedTrackerId}));
    this.setState({selectedTrackerId});
    this.updatePageTitle(selectedTrackerId);
  };

  render() {
    const {trackers, loading, selectedTrackerId} = this.state;

    if (!loading) {
      const [currentTracker] = _.filter(
        trackers,
        (fo) => fo.trackerId == selectedTrackerId
      );

      const cards = _.map(_.get(currentTracker, 'targets', []), (result) => (
        <Grid.Column width={4} height={4} key={result.id}>
          <Card>
            <Card.Content>
              <Header as="h3">{result.targetName}</Header>
              <Card.Description>
                <Header as="h6"> Recommended </Header>
                {showDollarAmountWithDollar(result.recommendedSum)} (
                {getPercentage(
                  result.recommendedSum,
                  result.softTarget
                    ? result.softTarget
                    : result.maxTarget
                    ? result.maxTarget
                    : result.minTarget
                )}
                )<Header as="h6">Target</Header>
                {showDollarAmountWithDollar(
                  result.softTarget
                    ? result.softTarget
                    : result.maxTarget
                    ? result.maxTarget
                    : result.minTarget
                )}             
                <br/>
                <br/>
                  <Link
                    to={
                      '/awardsTracker/' +
                      result.id +
                      '/trackerId/' +
                      selectedTrackerId +
                      '/name/' +
                      currentTracker.name
                    }
                    title={result.targetName}
                  >                   
                    VIEW              
                  </Link>                  
              </Card.Description>
            </Card.Content>
          </Card>
        </Grid.Column>
      ));

      return (
        <React.Fragment>
          <Main>
            <Container fluid>
              {trackers.length < 1 ? (
                <Alert
                  size="mini"
                  content="You do not have any Awards Trackers to view."
                  type="info"
                  dismissable={false}
                />
              ) : (
                <React.Fragment>
                  <Header as="h1">{currentTracker.name}</Header>
                  <Grid doubling stackable reversed="mobile" padded="vertically">
                    <Grid.Column width={8}>
                      <Form>
                        <h5>{`Select a funding opportunity`}</h5>
                        <TrackerDropDown
                          trackers={trackers}
                          handleChange={this.handleChange}
                          currentTracker={selectedTrackerId}
                        />
                      </Form>
                    </Grid.Column>
                  </Grid>
                  <Grid doubling stackable reversed="mobile" padded="vertically">
                    {cards}
                  </Grid>
                </React.Fragment>
              )}
            </Container>
          </Main>
        </React.Fragment>
      );
    }

    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
    jwt: state.auth.token,
  };
};
export default connect(mapStateToProps)(BusinessObjectivesTracker);
